import { useEffect } from 'react';
import { useLocation } from '@tanstack/react-router';
import { StoredUtmTags } from '@/shared/utils/Stored';

export default function useUtmTags() {
  const location = useLocation();
  useEffect(() => {
    const utmEntries = [...new URLSearchParams(location.searchStr)].filter(
      ([key]) => key.startsWith('utm_'),
    );
    // A utm-less navigation must not clobber tags captured on an earlier one.
    if (utmEntries.length > 0) {
      StoredUtmTags.set(Object.fromEntries(utmEntries));
    }
  }, [location.searchStr]);
}
